function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.038 23.969c0-.679.666-1.745 2.031-3.12 1.364 1.375 2.035 2.441 2.035 3.12a2.033 2.033 0 0 1-4.066 0zM4.231 18.892a.691.691 0 0 1-.163-.449v-6.249l7.818 4.349a2.033 2.033 0 0 0 1.975 0l7.821-4.349v6.249a.691.691 0 0 1-.172.449c-1.653 1.877-4.544 2.789-8.635 2.789s-6.986-.912-8.644-2.789zm21.306.52-.468-.441-.463.441c-.076.066-.144.136-.212.2V8.6L13.2 14.821a.687.687 0 0 1-.33.083.706.706 0 0 1-.334-.083L.351 8.044a.673.673 0 0 1 0-1.181L12.541.086a.683.683 0 0 1 .664 0l12.126 6.741a.68.68 0 0 1 .416.626v12.162a4.039 4.039 0 0 0-.209-.202z"
});

function SvgCollegeHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.105 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeHat);
export default __webpack_public_path__ + "static/media/college_hat.1283a872.svg";
export { ForwardRef as ReactComponent };